import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  statistic: generateApiPath({ prefix: AuthLevel.ADMIN, name: 'statistic' }),
}

export { paths }
